exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sign{padding:5% 2% 2%;width:90%;height:90%}#signature{border:2px dashed;border-radius:2px;margin-bottom:5px}", ""]);

// exports
